import { AfterViewInit, Directive, Host, HostListener, Input, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[matAutocompleteItemSelected]',
    standalone: true,
})
export class MatAutocompleteItemSelectedDirective implements AfterViewInit, OnDestroy {
	@Input() matAutocomplete: MatAutocomplete;

	protected readonly destroy$ = new Subject();

	constructor(@Host() @Self() private readonly autoCompleteTrigger: MatAutocompleteTrigger, private readonly ngControl: NgControl) {}

	@HostListener('focusout', ['$event'])
	onFocusout(): void {
		this.autoCompleteTrigger.panelClosingActions.pipe(first()).subscribe(() => {
			this.resetFormFieldIfInvalid();
			this.ngControl.control.markAsTouched();
		});
	}

	ngAfterViewInit(): void {
		this.autoCompleteTrigger.panelClosingActions.pipe(takeUntil(this.destroy$)).subscribe((e: MatOptionSelectionChange) => {
			if (!e || !e.source) {
				this.resetFormFieldIfInvalid();
			}
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}

	private resetFormFieldIfInvalid(): void {
		const selected = this.matAutocomplete.options.some((option) => option.value === this.ngControl.value);
		if (!selected) {
			this.ngControl.reset();
		}
	}
}
